module.exports = "https://static.wmbcdn.com/uniweb/images/806e9614c5d13508f734e4170849ac34.svg";